import { create } from "zustand";

interface Country {
  id: number;
  label: string;
  flag: string;
}

interface UserCountryState {
  selectedCountry: Country | null;
  selectedAdminCountry: Country | null;
  selectedCountryProduct: Country | null;

  setSelectedCountry: (country: Country | null) => void;
  setSelectedAdminCountry: (country: Country | null) => void;
  setSelectedCountryProduct: (country: Country | null) => void;
}

// Kenya & Rwanda country objects
const KENYA: Country = { id: 1, label: "Kenya", flag: "🇰🇪" };
const RWANDA: Country = { id: 2, label: "Rwanda", flag: "🇷🇼" };

// Determine country from the URL
const getInitialCountry = (): Country => {
  const href = window.location.href;

  if (
    href.includes("localhost:3000") ||
    href.includes("travelportaluat.britam.com") ||
    href.includes("travel.britam.com")
  ) {
    return KENYA;
  } else if (
    href.includes("localhost:3001") ||
    href.includes("travelrwandauat.britam.com") ||
    href.includes("travelrwanda.britam.com")
  ) {
    return RWANDA;
  }

  return KENYA; // default fallback
};

const useUserCountryStore = create<UserCountryState>((set) => ({
  selectedCountry: getInitialCountry(),
  selectedAdminCountry: null,
  selectedCountryProduct: null,

  setSelectedCountry: (country) => set({ selectedCountry: country }),
  setSelectedAdminCountry: (country) => set({ selectedAdminCountry: country }),
  setSelectedCountryProduct: (country) => set({ selectedCountryProduct: country }),
}));

export default useUserCountryStore;
